import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  TIndirectTaxCustomersHookParams,
  TIndirectTaxSellerCustomerRelationshipListResponse,
} from './types';

export function useIndirectTaxCustomers({
  corporationId,
  limit = 10,
  cursor = null,
  searchTerm = null,
  sortBy = null,
  sortOrder = null,
}: TIndirectTaxCustomersHookParams) {
  const query = new URLSearchParams();

  if (limit) {
    query.append('limit', limit.toString());
  }
  if (cursor) {
    query.append('cursor', cursor);
  }
  if (searchTerm) {
    query.append('search_term', searchTerm);
  }
  if (sortBy && sortOrder) {
    query.append('sort_by', sortBy);
    query.append('sort_order', sortOrder);
  }

  const { data, error, isLoading, mutate } =
    useSWR<TIndirectTaxSellerCustomerRelationshipListResponse>(
      corporationId
        ? `portal/sellers/${corporationId}/customers?${query}`
        : null,
      SWRFetcher({ method: 'GET' }, undefined),
      {
        keepPreviousData: true,
      }
    );

  return {
    data: {
      customers: data?.data.customers,
      nextCursor: data?.data.cursor,
      totalCustomers: data?.data.total_customers,
    },
    isLoading,
    error,
    mutate,
  };
}
